<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" v-b-modal.addSetting v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('setting.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditSetting()" v-if="permissionList.includes(permission.edit)">{{$t('setting.table_edit')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteSetting()" v-if="permissionList.includes(permission.delete)">{{$t('setting.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addSetting" :title="$t('setting.table_add')" @ok="addSetting" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addSettingForm" @submit.prevent="addSetting">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting.table_category')}}</template>
                            <b-form-input name="category" v-model="ajaxAdd.category"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxAdd.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting.table_value')}}</template>
                            <b-form-input name="value"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting.table_is_view')}}</template>
                            <b-form-checkbox name="is_view" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editSetting" :title="$t('setting.table_edit')" @ok="editSetting" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editSettingForm" @submit.prevent="editSetting">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting.table_category')}}</template>
                            <b-form-input name="category" v-model="ajaxEdit.category"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxEdit.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting.table_value')}}</template>
                            <b-form-input name="value" v-model="ajaxEdit.value"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting.table_is_view')}}</template>
                            <b-form-checkbox v-model="ajaxEdit.is_view" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {settingAjaxTable,settingAddCsrf,settingAdd,getSettingEdit,settingEdit,settingDelete} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',category:'',code:'',value:''},
            ajaxAdd:[],
            ajaxEdit:[],
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'A887BE',
                edit:'1BD415',
                delete:'6B372A'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('setting.table_id'),
                width: '50'
            },{
                prop: "category",
                label: this.$t('setting.table_category'),
                width: '200'
            },{
                prop: "code",
                label: this.$t('setting.table_code'),
                width: '300'
            },{
                prop: "value",
                label: this.$t('setting.table_value'),
                width: '150'
            },{
                prop: "is_view",
                label: this.$t('setting.table_is_view'),
                width: '150'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = settingAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.category,this.ajaxSearch.code,this.ajaxSearch.value);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },addSetting(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxAdd.category){
                    this.validate = false;
                    this.errors.push('setting.error_category_empty');
                }
                if(!this.ajaxAdd.code){
                    this.validate = false;
                    this.errors.push('setting.error_code_empty');
                }
                if(this.validate){
                    var form = document.getElementById('addSettingForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    var result = settingAdd(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    });    
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                    
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                }    
            }      
        },getEditSetting(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getSettingEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    if(value.valid){
                        self.preloader(false)
                        self.$bvModal.show('editSetting');
                        self.ajaxEdit = value.data;
                    }else{
                        self.preloader(true)
                        var text = "";
                        this.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        this.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editSetting(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxEdit.category){
                    this.validate = false;
                    this.errors.push('setting.error_category_empty');
                }
                if(!this.ajaxEdit.code){
                    this.validate = false;
                    this.errors.push('setting.error_code_empty');
                }
                if(this.validate){
                    var form = document.getElementById('editSettingForm');
                    var formData = new FormData(form);
                    console.log(form);
                    console.log(formData);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    formData.append('is_view', this.ajaxEdit.is_view); 
                    var result = settingEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                } 
            }
        },deleteSetting(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = settingDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
